import { render, staticRenderFns } from "./hall.vue?vue&type=template&id=3bb094ee&scoped=true&"
import script from "./hall.vue?vue&type=script&lang=js&"
export * from "./hall.vue?vue&type=script&lang=js&"
import style0 from "./hall.vue?vue&type=style&index=0&id=3bb094ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb094ee",
  null
  
)

export default component.exports